import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { getUnreadCount } from '@/lib/notifications-api';
import { useAuth } from '@/lib/auth-context';

export default function BellIcon() {
  const { status } = useAuth();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [pendingApprovals, setPendingApprovals] = useState(0);

  const poll = useCallback(async () => {
    try {
      const r = await getUnreadCount();
      setCount(r.unread_count || 0);
      setPendingApprovals(r.pending_approvals_count || 0);
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    if (status !== 'signed-in') return;
    poll();
    const iv = setInterval(poll, 20000);
    return () => clearInterval(iv);
  }, [status, poll]);

  const attention = pendingApprovals > 0;

  return (
    <button
      onClick={() => navigate('/notifications')}
      className={`relative p-2 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#146BFF] ${
        attention
          ? 'bg-[#FFF6E5] border border-[#B86500] hover:bg-[#FBEEDA]'
          : 'hover:bg-slate-100'
      }`}
      data-testid="bell-icon"
      aria-label="Notifications"
    >
      <Bell className={`w-5 h-5 ${attention ? 'text-[#B86500]' : 'text-[#0B1B46]'}`} />
      {count > 0 && (
        <span
          className={`absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1 border-2 border-white ${
            attention ? 'bg-[#B86500]' : 'bg-[#146BFF]'
          }`}
          data-testid={attention ? 'bell-badge-attention' : 'bell-badge'}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
